import { Box, TextField, Typography } from '@mui/material'
import { createFyaItem, updateFyaItem } from 'api/services/automation/income-tax'
import DialogWrapper from 'components/DialogWrapper'
// import FormSelect from 'components/FormFields/FormSelect'
import LoadingButton from 'components/LoadingButton'
import { snack } from 'components/toast'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { getFinancialYears } from 'utils/getFinancialYears'
import { handleError } from 'utils/handleError'

interface fyaItem {
  assessmentYear: string;
  section: string;
  proceedingName: string;
  panNumber: string;
  type: string;
}

const EditClientFya = ({ open, setOpen, data, clientName }) => {
  const queryClient = useQueryClient()
  const params = useParams()
  const { control, handleSubmit, reset, register } = useForm<fyaItem>({
    defaultValues: {
      assessmentYear: "",
      section: "",
      proceedingName: "",
      panNumber: "",
      type: "Self"
    },
    mode: "onChange"
  })

  useEffect(() => {
    reset({
      assessmentYear: `${data?.assesmentYear}-${Number(data?.assesmentYear) + 1}`,
      section: data?.noticeName,
      proceedingName: data?.proceedingName,
      panNumber: data?.pan,
      type: data?.type || "Self"
    })
  }, [data, reset])

  const { mutate, isLoading } = useMutation(updateFyaItem, {
    onSuccess: () => {
      snack.success("Fya Proceeding Updated")
      queryClient.invalidateQueries("client-proceeding-fya")
      reset()
      setOpen(false)
    },
    onError: (error) => {
      snack.error(handleError(error))
    }
  })

  const onSubmit = async (item) => {
    console.log(item)

    if (item?.proceedingName && item?.proceedingName?.trim().length < 1) {
      return snack.error("Proceeding Name is mandatory")
    }
    item.proceedingName = item?.proceedingName.trim()
    if (item?.assessmentYear && item?.assessmentYear?.trim().length < 1) {
      return snack.error("Assessment Year is mandatory")
    }

    const updatedDate = {
      ...data,
      noticeName: item?.section,
      proceedingName: item?.proceedingName,
      pan: item?.panNumber,
      type: item?.type,
      assesmentYear: item?.assessmentYear?.split('-')[0],
      financialYear: String(Number(item?.assessmentYear?.split('-')[0]) - 1)
    }

    await mutate(updatedDate)
  }



  return (
    <DialogWrapper open={open} setOpen={setOpen} title="Edit FYA">
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* <Box mt={1}>
          <FormSelect
            control={control}
            name="type"
            label="Type"
            size='medium'
            required
            options={["Self", "Other"]?.map((item) => ({
              label: item,
              value: item,
            }))}
          />
        </Box> */}
        <Box mt={1}>
          <TextField
            label="Name"
            fullWidth
            size='medium'
            value={clientName}
            disabled
          />
        </Box>
        <Box mt={1}>
          <TextField
            label="Section"
            fullWidth
            size="medium"
            {...control.register(`section` as const)}
          />
        </Box>
        <Box mt={1}>
          <TextField
            label="Procceding Name"
            size='medium'
            fullWidth
            required
            {...control.register(`proceedingName` as const)}
          />
        </Box>
        {/* <Box mt={1}>
          <FormSelect
            control={control}
            name="assessmentYear"
            label="Assessment Year"
            size="medium"
            required
            options={getFinancialYears().map((item) => ({
              label: item,
              value: item,
            }))}

          />


        </Box> */}
        <Box mt={1}>
          <LoadingButton

            loading={isLoading}
            disabled={isLoading}
            loadingColor='white'
            type="submit"
            title="Submit"
            color="secondary"
          />
        </Box>
      </form>
    </DialogWrapper>
  )
}

export default EditClientFya